/* unplugin-vue-components disabled */import { render } from "./Thumbnail.vue?vue&type=template&id=5687296a"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"

import "./Thumbnail.vue?vue&type=style&index=0&id=5687296a&lang=scss&sccoped=true"

import exportComponent from "/data/repos/231_20260522130100/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__